module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "active-items"
  }, [_c('div', {
    staticClass: "active-items-title-read"
  }, [_c('div', {
    staticClass: "active-item-read flex-between"
  }, [(_vm.row.cate_list) ? _c('div', {
    staticClass: "active-item-label",
    style: (_vm.row.cate_list.length > 0 && _vm.row.cate_list[0].name == '视频' ?
      'background: linear-gradient(96deg, #0091FF 0%, #F4FAFF 100%);' : '')
  }, _vm._l((_vm.row.cate_list), function(cate, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(cate.name) + "  ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active-item-read-num"
  }, [_vm._v(_vm._s(_vm.row.views_count) + "阅读")])]), _vm._v(" "), _c('div', {
    staticClass: "active-item-title flex-start"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/other/icon-yinhao-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "active-item-title-text"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/other/icon-yinhao-2.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "active-item-pics"
  }, _vm._l((_vm.row.pics_url), function(item) {
    return _c('div', {
      key: item,
      staticClass: "active-item-li"
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ab2450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/NewsItem4.vue
// module id = 2171
// module chunks = 0